import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import Link from "next/link";
import { FacebookIcon, InstagramIcon, LinkedInIcon, TwitterIcon, BlueSkyIcon, YouTubeIcon, MastodonIcon, TikTokIcon, ThreadsIcon, WhatsAppIcon } from "common/components/icons/social";
interface SocialMediaLinkProps {
  icon: string;
  href: string;
  title?: string;
}
interface SocialMediaIconProps {
  icon: string;
}
const SocialMediaIcon = t0 => {
  "use memo";

  const $ = _c(10);
  const {
    icon
  } = t0;
  switch (icon) {
    case "facebook":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group hover:bg-facebook flex size-14 rounded-full bg-white lg:size-11"><FacebookIcon className="fill-facebook m-auto size-5 group-hover:fill-white lg:size-4" /></div>;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "twitter":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group hover:bg-twitter flex size-14 rounded-full bg-white lg:size-11"><TwitterIcon className="fill-twitter m-auto size-5 group-hover:fill-white lg:size-4" /></div>;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "bluesky":
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group hover:bg-bluesky flex size-14 rounded-full bg-white lg:size-11"><BlueSkyIcon className="fill-bluesky m-auto size-5 group-hover:fill-white lg:size-4" /></div>;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "instagram":
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group hover:bg-instagram flex size-14 rounded-full bg-white lg:size-11"><InstagramIcon className="fill-instagram m-auto size-5 group-hover:fill-white lg:size-4" /></div>;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "linkedin":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group hover:bg-linkedin flex size-14 rounded-full bg-white lg:size-11"><LinkedInIcon className="fill-linkedin m-auto size-5 group-hover:fill-white lg:size-4" /></div>;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case "youtube":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group hover:bg-youtube flex size-14 rounded-full bg-white lg:size-11"><YouTubeIcon className="fill-youtube m-auto size-5 group-hover:fill-white lg:size-4" /></div>;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "mastodon":
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group hover:bg-mastodon flex size-14 rounded-full bg-white lg:size-11"><MastodonIcon className="fill-mastodon m-auto size-5 group-hover:fill-white lg:size-4" /></div>;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case "tiktok":
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group flex size-14 rounded-full bg-white hover:bg-black lg:size-11"><TikTokIcon className="m-auto size-5 fill-black group-hover:fill-white lg:size-4" /></div>;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "whatsapp":
      {
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group hover:bg-whatsapp flex size-14 rounded-full bg-white lg:size-11"><WhatsAppIcon className="fill-whatsapp m-auto size-5 group-hover:fill-white lg:size-4" /></div>;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case "threads":
      {
        let t1;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="group flex size-14 rounded-full bg-white hover:bg-black lg:size-11"><ThreadsIcon className="m-auto size-5 fill-black group-hover:fill-white lg:size-4" /></div>;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
};
export const SocialMediaLink = t0 => {
  "use memo";

  const $ = _c(6);
  const {
    icon,
    title,
    href
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <SocialMediaIcon icon={icon} />;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== href || $[3] !== t1 || $[4] !== title) {
    t2 = <Link href={href} title={title} rel="me">{t1}</Link>;
    $[2] = href;
    $[3] = t1;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};